import React from 'react';
import { UserContext } from '..';
import { useWrapRequest } from '../../../components/hooks/use-wrap-request';
import { Api } from '../../../core/api';
import {
    FitnessAppBackfillRequestDto,
    UserFitnessAppSupportDto
} from '../../../core/api/MobileClient';
import { injectTSDI } from '../../../core/tsdi';

export type { UserFitnessAppSupportDto, FitnessAppBackfillRequestDto };

export function useUserFitnessAppsStore() {
    const { mobileClient } = injectTSDI(Api);
    const user = React.useContext(UserContext);

    const connections = useWrapRequest(
        async (userId: number) => {
            const result =
                await mobileClient.supportApi.userFitnessAppSupportControllerGetConnections(
                    userId
                );

            return result.data;
        },
        {
            deps: [user.id],
            defaultData: [] as UserFitnessAppSupportDto[]
        }
    );

    const triggerBackfill = async (request: FitnessAppBackfillRequestDto) => {
        await mobileClient.supportApi.fitnessAppBackfillSupportControllerBackfill(
            request
        );
    };

    const refresh = () => {
        connections.request([user.id]);
    };

    return {
        connections,
        triggerBackfill,
        refresh,
        userId: user.id
    };
}
